import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HttpOptionsFactory } from '../../../models/http/http-options-factory'
import { Observable } from 'rxjs'
import { UrlCollection } from '../../../url-collection'
import { QuickNote } from '../models/quicknote'

@Injectable({
  providedIn: 'root'
})
export class QuickNoteService {
  constructor(private http: HttpClient) {}

  get(dtoType: string, id: number): Observable<QuickNote> {
    return this.http.get<QuickNote>(
      UrlCollection.QuickNotes.GET(dtoType, id),
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  update(quicknote: QuickNote): Observable<void> {
    return this.http.post<void>(
      UrlCollection.QuickNotes.UPDATE(),
      quicknote,
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  remove(quicknote: QuickNote): Observable<void> {
    return this.http.post<void>(
      UrlCollection.QuickNotes.REMOVE(),
      quicknote,
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }
}
